import React, { Component } from "react";

const THEME_KEY = "nova-theme";

function preferredTheme() {
    const savedTheme = window.localStorage.getItem(THEME_KEY);
    if (savedTheme === "light" || savedTheme === "dark") return savedTheme;
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

class ThemeToggle extends Component {
    constructor(props) {
        super(props);
        this.state = { theme: preferredTheme() };
    }

    componentDidMount() {
        this.applyTheme(this.state.theme);
        document.documentElement.dataset.device = this.detectDevice();
    }

    applyTheme = (theme) => {
        document.documentElement.dataset.theme = theme;
        document.documentElement.style.colorScheme = theme;
        document.body.classList.remove("dark");
        document.body.classList.toggle("nova-dark", theme === "dark");
        window.localStorage.setItem(THEME_KEY, theme);
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (themeMeta) themeMeta.setAttribute("content", theme === "dark" ? "#07111f" : "#f4f7fb");
    };

    detectDevice = () => {
        const userAgent = navigator.userAgent || "";
        const narrowScreen = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
        return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(userAgent) || narrowScreen ? "mobile" : "desktop";
    };

    toggleTheme = () => {
        const theme = this.state.theme === "dark" ? "light" : "dark";
        this.setState({ theme });
        this.applyTheme(theme);
    };

    render() {
        const isDark = this.state.theme === "dark";
        const walletPage = /^\/(dashboard|wallet|transaction|PaymentBox)/.test(window.location.pathname);
        return (
            <button type="button" className={`nova-theme-toggle${walletPage ? " nova-theme-toggle-wallet" : ""}`} onClick={this.toggleTheme}
                aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
                title={`Switch to ${isDark ? "light" : "dark"} mode`}>
                <span aria-hidden="true">{isDark ? "☀" : "☾"}</span>
                <span className="nova-theme-label">{isDark ? "Light" : "Dark"}</span>
            </button>
        );
    }
}

export default ThemeToggle;
